module.exports = __webpack_public_path__ + "img/levelup-products-courses.f6200625.svg";